import ProtectedPage from '@/components/ProtectedPage'
import WavyLogo from '@/components/svgs/WavyLogo'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { format } from 'date-fns'
import { Link, useLocalSearchParams } from 'expo-router'
import { View } from 'react-native'

export default function VrdhCallConfirmedScreen() {
	const { startsAt } = useLocalSearchParams<{ startsAt: string }>()
	const startTime = format(startsAt ?? Date.now(), 'h:mm b')
	const startDate = format(startsAt ?? Date.now(), 'M/d/yyyy')

	return (
		<ProtectedPage>
			<View className="flex-1 lg:flex-row flex">
				<View className="lg:h-full lg:w-1/2 h-1/4">
					<WavyLogo width="100%" height={'100%'} />
				</View>
				<Screen className="relative flex-1" preset="fixed">
					<VStack
						fullHeight
						className="lg:mt-0 mt-16 lg:h-dvh justify-center items-center"
						gap={48}
					>
						<VStack className="px-16 items-center" gap={36}>
							<Header className="text-center" variant="h1">
								You're all set!
							</Header>
							<Text className="text-pretty text-center max-w-60">
								{`We'll be giving you a call at ${startTime} on ${startDate} so have your phone ready.`}
							</Text>
						</VStack>
						<View className="h-24">
							<Link asChild href={'/'}>
								<Button size="sm">
									<ButtonText>Go home</ButtonText>
								</Button>
							</Link>
						</View>
					</VStack>
				</Screen>
			</View>
		</ProtectedPage>
	)
}
